import videoCardHover from "../../shared/videoCardHover";

export default () => {
  videoCardHover();
};
